export default "__VITE_ASSET__DiFhfXGr__"